import './team-scouting.styles.scss';
import { Link } from 'react-router-dom';
import { DEFENSES, DEPTHS, OFFENSES, PACES, strategyLabel } from '@shared/strategy.js';

// Scouting: what a team usually runs (games run with each offense and
// defense, team.systemGames) and what it ran last time (team.strategy).
// reportLink: the full scouting report page (manager side).
const TeamScouting = ({ team, reportLink }) => {

    const games = team.systemGames;
    if (!games) return reportLink ? <div className='g-card team-scouting'><h3>Scouting</h3><Link to={reportLink}>Scouting report</Link></div> : null;
    const usual = (cat, list) => Object.entries(games[cat] ?? {})
        .filter(([, n]) => n >= 1)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 2)
        .map(([key, n]) => `${strategyLabel(list, key)} (${Math.round(n)})`)
        .join(', ');
    const last = team.strategy;

    return (
        <div className='g-card team-scouting'>
            <h3>Scouting</h3>
            <dl className='scouting-list'>
                <dt>Offense</dt><dd>{usual('offense', OFFENSES) || '-'}</dd>
                <dt>Defense</dt><dd>{usual('defense', DEFENSES) || '-'}</dd>
                {last &&
                    <>
                        <dt>Last game</dt>
                        <dd>
                            {strategyLabel(OFFENSES, last.offense)} · {strategyLabel(DEFENSES, last.defense)} ·{' '}
                            {strategyLabel(PACES, last.pace)} pace · {strategyLabel(DEPTHS, last.depth)} rotation
                        </dd>
                    </>
                }
            </dl>
            <p className='meta'>Numbers are recent games run with each system.</p>
            {reportLink && <Link to={reportLink} className='scouting-report-link'>Full scouting report</Link>}
        </div>
    )
}

export default TeamScouting
